import { createSlice } from '@reduxjs/toolkit';
import { fetchInvoiceFundingApplications } from '../features/invoiceFundingApplications/invoiceFundingApplicationsActions';

const initialState = {
  loading: false,
  applications: [],
  error: '',
};

const invoiceFundingApplicationsSlice = createSlice({
  name: 'invoiceFundingApplications',
  initialState,
  reducers: {
    // You can keep synchronous actions here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoiceFundingApplications.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchInvoiceFundingApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.applications = action.payload;
      })
      .addCase(fetchInvoiceFundingApplications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default invoiceFundingApplicationsSlice.reducer;
